import { ContaBancaria } from '../services/hooks/useContasBancarias';

// Aqui a conta casa quando o ACCTID termina no número dela, com ou sem dígito.
export function contaCombina(
  conta: ContaBancaria,
  acctId: string | null,
): boolean {
  if (!acctId) return false;
  const doArquivo = acctId.replace(/[^0-9]/g, '').replace(/^0+/, '');
  const numero = (conta.numero_cts ?? '')
    .replace(/[^0-9]/g, '')
    .replace(/^0+/, '');
  // Número curto demais casaria com quase qualquer ACCTID por sufixo.
  if (numero.length < 4 || doArquivo === '') return false;
  const digito = (conta.digito_cts ?? '').replace(/[^0-9]/g, '');
  return (
    doArquivo === numero ||
    doArquivo.endsWith(numero) ||
    (digito !== '' && doArquivo.endsWith(`${numero}${digito}`))
  );
}

// O BANKID vem ora '1', ora '001', ora '0237'; o confcomp_ban do IFLEX é
// inteiro. Comparar como número resolve os dois lados.
//
// Só acusa divergência quando os dois lados existem: arquivo sem BANKID (é o
// caso do extrato de cartão, que usa CCACCTFROM) ou banco sem código de
// compensação cadastrado não são motivo para barrar a importação.
export function bancoDivergente(
  conta: ContaBancaria | undefined,
  bankId: string | null,
): boolean {
  if (!conta || !bankId) return false;
  const doArquivo = parseInt(bankId.replace(/[^0-9]/g, ''), 10);
  const daConta = parseInt(conta.confcomp_ban ?? '', 10);
  if (Number.isNaN(doArquivo) || Number.isNaN(daConta)) return false;
  return doArquivo !== daConta;
}
